import Field from '../common/Field';
import { errorTooltip } from '../common/tooltip';
import handleSelect from '../handle-select';

const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const createFormManager = ({
  form,
  validations,
  toggleError,
  sendCallback,
}) => {
  const fieldsInstances = Array.from(form.querySelectorAll('input, textarea'))
    .filter(({ name }) => !!name)
    .map((field) => new Field(field, validations, toggleError));

  const select = handleSelect(form.getElementsByTagName('select')[0]);
  const defaultSelectValue = select.getValue();
  const selectField = new Field(
    form.getElementsByTagName('select')[0],
    validations,
    toggleError,
  );
  selectField.getValue = () => select.getValue(true);

  selectField.reset = function () {
    this.element.value = defaultSelectValue;
    this.error = null;
    this.touched = false;
    select.destroy();
    select.init();
  };

  fieldsInstances.push(selectField);

  const setErrors = (errors) => {
    fieldsInstances.forEach((field) => {
      if (errors[field.name]) {
        field.error = errors[field.name];
        field.toggleError();
      }
    });
  };

  const resetFields = () => fieldsInstances.forEach((field) => field.reset());

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    let haveError = false;
    fieldsInstances.forEach((instance) => {
      if (instance.preSendValidation()) haveError = true;
    });

    if (haveError) return;
    const values = fieldsInstances.reduce((acc, field) => {
      acc[field.name] = field.getValue();

      if (acc[field.name] instanceof Array) {
        acc[field.name] = acc[field.name].join(', ');
      }
      return acc;
    }, {});

    sendCallback(values, resetFields, setErrors);
  });
};

export default (formId, sendCallback) => {
  const validations = {
    fullname: (value) => {
      if (value.length < 1) return 'Required field';
    },
    company_name: (value) => {
      if (value.length < 1) return 'Required field';
    },
    email: (value) => {
      if (!value || value.length < 1) return 'Required field';
      if (value.search(emailReg) === -1) return 'Incorrect E-Mail Address';
    },
  };

  const form = document.getElementById(formId);

  // const invalidClasses = {
  //   fullname: {
  //     element: 'base-input-invalid',
  //     parent: 'base-input-wrap-invalid',
  //   },
  //   company: {
  //     element: 'base-input-invalid',
  //     parent: 'base-input-wrap-invalid',
  //   },
  //   email: {
  //     element: 'base-input-invalid',
  //     parent: 'base-input-wrap-invalid',
  //   },
  // };

  const toggleError = (element, error, touched) => {
    const parent = element.parentNode;
    // const elementClassNames = element.className.split(' ');
    // const parentClassNames = parent.className.split(' ');
    // const elementInvalidClassName = invalidClasses[element.name]?.element;
    // const parentInvalidClassName = invalidClasses[element.name]?.parent;

    if (error && touched) {
      // if (
      //   elementInvalidClassName &&
      //   elementClassNames.indexOf(elementInvalidClassName) === -1
      // ) {
      //   element.className = elementClassNames
      //     .concat(elementInvalidClassName)
      //     .join(' ');
      // }

      // if (
      //   parentInvalidClassName &&
      //   parentClassNames.indexOf(parentInvalidClassName) === -1
      // ) {
      //   parent.className = parentClassNames
      //     .concat(parentInvalidClassName)
      //     .join(' ');
      // }

      if (element.type !== 'checkbox') errorTooltip.add(parent, error);
    } else if (!error) {
      if (element.type !== 'checkbox') errorTooltip.remove(parent);

      // if (elementClassNames.indexOf(elementInvalidClassName) !== -1) {
      //   element.className = elementClassNames
      //     .filter((className) => className !== elementInvalidClassName)
      //     .join(' ');
      // }

      // if (parentClassNames.indexOf(parentInvalidClassName) !== -1) {
      //   parent.className = parentClassNames
      //     .filter((className) => className !== parentInvalidClassName)
      //     .join(' ');
      // }
    }
  };

  createFormManager({ form, validations, toggleError, sendCallback });
};
